import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=80f8b3d2&scoped=true&"
import script from "./sidebar.ts?vue&type=script&lang=ts&"
export * from "./sidebar.ts?vue&type=script&lang=ts&"
import style0 from "./sidebar.scss?vue&type=style&index=0&id=80f8b3d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f8b3d2",
  null
  
)

export default component.exports